var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDocumentSmall = function SvgDocumentSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M11.667 1.892v3.442c0 .466 0 .7.091.878.08.157.208.284.364.364.179.091.412.091.879.091h3.442m-4.776 7.5h-5m6.667-3.333H6.667m10-2.51v6.01c0 1.4 0 2.1-.272 2.635a2.5 2.5 0 0 1-1.093 1.092c-.534.273-1.235.273-2.635.273H7.334c-1.4 0-2.1 0-2.635-.273a2.5 2.5 0 0 1-1.093-1.092c-.272-.535-.272-1.235-.272-2.635V5.667c0-1.4 0-2.1.272-2.635A2.5 2.5 0 0 1 4.7 1.939c.535-.272 1.235-.272 2.635-.272h2.677c.61 0 .917 0 1.204.07a2.5 2.5 0 0 1 .723.298c.252.155.468.371.9.804l2.658 2.656c.432.433.648.649.803.901.137.224.238.468.3.723.068.288.068.593.068 1.205"
  })));
};
export default SvgDocumentSmall;